<template>
  <div id="page-wrapper" :class="popupShown ? 'popup-shown' : ''">

    <transition name="teampopupdash">
      <div id="popup-wrapper" v-if="popupShown">
        <template>
          <button class="btn btn-link text-white close" @click.prevent.stop="closePopup">
            <i class="fal fa-times"></i>
          </button>
          <h2>
            {{user.fullname}}
            <span class="pl-3 small text-muted">{{formatDate(popupSubmission.finalized ? popupSubmission.finalized : popupSubmission.submitted)}}
          </span>
          </h2>

          <user-review @close="closePopup" :user="user" :submission="popupSubmission"></user-review>
        </template>
      </div>
    </transition>
    <div id="page">
      <app-header></app-header>
      <div class="page-body">
        <app-navbar></app-navbar>
        <div class="main-page-content  ml-0">
          <div id="main-wrapper" class="layout-main-wrapper clearfix">
            <div id="main" class="container-fluid">
              <div class="row row-offcanvas row-offcanvas-left clearfix">
                <main class="main-content col content-full-width" id="content" role="main">
                  <section id="dashboard" class="section">
                    <div class="row mb-30">
                      <vitamins
                        @openCurrent="openSubmissionPopup"
                        :current="current"
                        :vitaminScores="vitaminScores"
                        :vitamins="vitamins">
                      </vitamins>
                      <current
                        :current="current"
                        :vitamins="vitamins">
                      </current>
                    </div>
                    <div class="row">
                      <div class="col-md-12 col-xxl-12">
                        <evolution
                          :vitaminScores="vitaminScores"
                          :vitamins="vitamins">
                        </evolution>
                      </div>
                    </div>
                  </section>
                </main>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

  import Evolution from './Evolution.vue'
  import Vitamins from './Vitamins.vue'
  import Header from "../Header";
  import Nav from "../Nav";
  import store from "../../store/store";
  import UserReview from "../Review/UserReview"
  import moment from 'moment'
  import Current from './Current';

  export default {
    components: {
      Evolution,
      store,
      appHeader: Header,
      appNavbar: Nav,
      Current,
      Vitamins,
      UserReview,
    },
    data() {
      return {
        user: store.getters.getUser,
        vitamins: [],
        vitaminScores: {},
        current: {},
        popupShown: false,
        popupSubmission: null,
      }
    },

    methods: {
      openSubmissionPopup() {
        this.popupSubmission = this.current;
        this.popupShown = true;
      },
      closePopup() {
        this.popupShown = false;
      },
      getVitamins() {
        this.axios.get('/vitamines?_sort=sort:ASC&published=1').then(vitamins => vitamins.data)
          .then(res => {
            this.vitamins = res;
            this.vitamins.forEach(vitamin => {
              this.vitaminScores[vitamin.id] = vitamin
            })
          });
      },
      getCurrentSubmission() {
        this.axios.get('/submissions?_sort=finalized:DESC&_limit=1')
          .then(r => {
            this.current = r.data[0];
          })
      },
    },

    created() {
      this.getVitamins();
      this.getCurrentSubmission()
    },
  }
</script>

<style>
  @keyframes slide-in {
    from {
      top: -200%;
    }
    to {
      top: 0;
    }
  }

  @keyframes slide-out {
    from {
      top: 0;
    }
    to {
      top: -200%;
    }
  }

  .teampopupdash-enter {

  }

  .teampopupdash-enter-active {
    animation: slide-in .5s ease-out forwards;
  }

  .teampopupdash-leave {

  }

  .teampopupdash-leave-active {
    animation: slide-out .5s ease-out forwards;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Dashboard.vue